import {
  SET_ACTIVE_STATUS,
  SET_IS_USER_SITE_ADMIN,
  SET_ALERT,
  SET_FILTERS,
  SET_AUDIENCES,
  ADD_AUDIENCE,
  REMOVE_AUDIENCE,
  SET_TOPICS,
  REMOVE_TOPIC,
  ADD_TOPIC,
  SET_POPULATION_SEGMENTS,
} from '../actionTypes';

const initialState = {
  activeStatus: '',
  isUserSiteAdmin: false,
  alert: null,
  tileStatusNav: {
    user_submitted: {
      filter: {
        audience: null,
        month: null,
        ribbonTag: null,
        sortType: null,
        year: null,
      },
      page: 1,
      tileCount: 0,
      uiDisplay: "Suggested",
    },
    plan: {
      filter: {
        audience: null,
        month: null,
        ribbonTag: null,
        sortType: null,
        year: null,
      },
      page: 1,
      tileCount: 0,
      uiDisplay: "Plan",
    },
    draft: {
      filter: {
        audience: null,
        month: null,
        ribbonTag: null,
        sortType: null,
        year: null,
      },
      page: 1,
      tileCount: 0,
      uiDisplay: "Proof",
    },
    active: {
      filter: {
        audience: null,
        month: null,
        ribbonTag: null,
        sortType: null,
        year: null,
      },
      page: 1,
      tileCount: 0,
      uiDisplay: "Live",
    },
    archive: {
      filter: {
        audience: null,
        month: null,
        ribbonTag: null,
        sortType: null,
        year: null,
      },
      page: 1,
      tileCount: 0,
      uiDisplay: "Archive",
    },
  },
  audiences: [],
  ribbonTags: [],
  populationSegments: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_STATUS: {
      return {
        ...state,
        activeStatus: action.payload
      };
    }
    case SET_IS_USER_SITE_ADMIN: {
      return {
        ...state,
        isUserSiteAdmin: action.payload
      };
    }
    case SET_ALERT: {
      return {
        ...state,
        alert: action.payload
      }
    }
    case SET_FILTERS: {
      return {
        ...state,
        tileStatusNav: action.payload
      }
    }
    case SET_AUDIENCES: {
      return {
        ...state,
        audiences: action.payload
      }
    }
    case ADD_AUDIENCE: {
      const audience = action.payload;
      const audiences = state.audiences.concat({ ...audience });
      return {
        ...state,
        audiences: audiences
      }
    }
    case REMOVE_AUDIENCE: {
      const audience = action.payload;
      const audiences = state.audiences.filter((c) => ![c.value, c.id].includes(audience.value || audience.id));

      return {
        ...state,
        audiences: audiences
      }
    }
    case REMOVE_TOPIC: {
      const topic = action.payload;
      const ribbonTags = state.ribbonTags.filter((c) => ![c.value, c.id].includes(topic.value || topic.id));

      return {
        ...state,
        ribbonTags: ribbonTags
      }
    }
    case SET_TOPICS: {
      return {
        ...state,
        ribbonTags: action.payload
      }
    }
    case ADD_TOPIC: {
      const topic = action.payload;
      const topics = state.ribbonTags.concat({ ...topic, value: topic.id, label: topic.name });

      return {
        ...state,
        ribbonTags: topics
      }
    }
    case SET_POPULATION_SEGMENTS: {
      return {
        ...state,
        populationSegments: action.payload,
      }
    }
    default:
      return state;
  }
}
